import { unformatMMFGDate } from '@/addons/date'
import { isWithinInterval } from 'date-fns'

// Verifica se la data attuale è compresa tra data_inizio e data_fine.
// Restituisce true se data_fine è assente o se oggi è all'interno dell'intervallo.
export function isInRange(data): boolean {
  const { data_inizio, data_fine } = data
  if (!data_fine) {
    return true
  }
  const unformattedDataInizio = unformatMMFGDate(data_inizio)
  const unformattedDataFine = unformatMMFGDate(data_fine)
  const today = new Date()
  return isWithinInterval(today, {
    start: unformattedDataInizio,
    end: unformattedDataFine,
  })
}

const FIDELITY_CONSUMER_EXTRA_FIELDS = [
  'active',
  'valid',
  'membership_duration',
  'card_status',
  'points_base',
  'points_frozen',
  'points_promo',
  'points_temporary',
  'points_temporary_details',
  'points_delayed_details',
  'goals',
  'steps_type',
  'steps_start_date',
  'steps_end_date',
  'steps',
  'owner_code',
  'level_ranges',
]

export function pickFidelityConsumerDetails(source: Record<string, any>) {
  const fidelityConsumerDetails: Record<string, any> = {}
  for (const k of FIDELITY_CONSUMER_EXTRA_FIELDS) {
    if (k in source) {
      fidelityConsumerDetails[k] = source[k]
    }
  }
  return fidelityConsumerDetails
}
